import { Tooltip } from '@mantine/core';
import { FC, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    label?: string;
}

const ConditionalTooltip: FC<Props> = ({ children, label }) => {
    if (!label) {
        return <>{children}</>;
    }

    return (
        <Tooltip withArrow label={label}>
            {children}
        </Tooltip>
    );
};

export default ConditionalTooltip;
